import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { CaeUserService } from 'src/app/Service/cae-user-service.service';
import { EventService } from 'src/app/Service/event.service';
import { TranslateService } from '@ngx-translate/core';
import { ErrorCustomService } from 'src/app/Service/error-service.service';
import { FormBuilder } from '@angular/forms';
import { AuthService } from 'src/app/Service/auth.service';
import { HttpClient } from '@angular/common/http';
import { utilsApps } from 'src/app/helpers/utils-app';
import { DetailsWokingDayService } from '../../service/details-woking-day.service';
import { ActivatedRoute } from '@angular/router';
import { PaginationTableService } from 'src/app/modules/shared/pagination/pagination-table/pagination-table.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { DomSanitizer } from '@angular/platform-browser';
import { DetailsWokingDayAPIService } from '../../service/details-woking-day-api.service';

@Component({
  selector: 'app-details-woking-day',
  templateUrl: './details-woking-day.component.html',
  styleUrls: ['./details-woking-day.component.css']
})
export class DetailsWokingDayComponent implements OnInit {
  @Input() childId: string;


  /** Variables of pagination */
  protected totalPages: any[] = [];
  protected currentPage: number = 1;
  totalItems: number;

  dataInformation = <any>[];
  resetTable = false;
  emptyDataList: boolean = true;
  IsPostBack = false;
  msgDataEmpty: string = "El criterio de búsqueda ingresado no existe.";

  waitFor = false;
  //Entidad para detalles del usuario
  public userDetail: any = {
    fullname: '',
    groupName: '',
    email: '',
    idPlatform: '',
    dateInit: '',
    filePhoto: '',
    totalHours: 0
  };

  _group: any = {
    contextual: '',
    name: ''
  };

  public dataGrid: any[] = [];

  modalRef: BsModalRef;
  modalConfig = {
    backdrop: true,
    ignoreBackdropClick: false,
    keyboard: false,
    class: '',
  };

  imagePath: any;

  constructor(
    private readonly _modalService: NgbModal,
    protected eventService: EventService,
    private readonly _service: CaeUserService,
    private readonly _serviceWokingDay: DetailsWokingDayService,
    private readonly _serviceWokingDayAPI: DetailsWokingDayAPIService,
    private readonly translate: TranslateService,
    private readonly _errorS: ErrorCustomService,
    private readonly authService: AuthService,
    private _sanitizer: DomSanitizer,
    private readonly paginationTableService: PaginationTableService,

    private readonly route: ActivatedRoute,
    private readonly _config: NgbModalConfig,
    private fb: FormBuilder,
    private readonly modalService: BsModalService,
    private httpClient: HttpClient
  ) {
    // Configuración para modal global
    this._config.backdrop = 'static';
    this._config.keyboard = false;
  }



  ngOnInit() {
    this.childId = this.route.snapshot.paramMap.get('id');

    this.currentPage = parseInt(localStorage.getItem('currentPage') ?? this.paginationTableService.resetPageCurrent().toString());
    console.log("childId =>", this.childId);
    this.onLoadEntity();
    this.onLoadGrid(false);
  }



  fmFilters = this.fb.group({
    txtDateInit: [new Date()],
    txtDateEnd: [new Date()],
  });

  public getDateInitMonth() {
    let currentDate = new Date();
    return new Date(
      currentDate.getFullYear() + '/' + (currentDate.getMonth() + 1) + '/01'
    );
  }

  removeFilter() {
    this.fmFilters = this.fb.group({
      txtDateInit: [new Date()],
      txtDateEnd: [new Date()],
    });
  }


  onDownloadDataGrid() {
    this.waitFor = true;
    this.eventService.startLoadingData();
    try {

      let _parametros = this.getParameters();

      this._serviceWokingDayAPI.getReportFile(_parametros, this.currentPage).subscribe({
        next: res => {
          console.log(res);
          let result = res.body;

          if (res.status == 200) {
            if (result.code == "SUCCESS") {
              let _fileName = "report_working_day_details";
              let _utils = new utilsApps();
              let content = result.content;
              _utils.downloadFileFromB64(content, _fileName, '.xlsx');
            } else {
              this.eventService.warningMessage("common.catMsg.warningDataNotFound");
            }
          }
          else {
            this.eventService.errorMessage(0, "common.catMsg.errorRequest");
          }

          this.eventService.completeLoadingData();
          this.waitFor = false;

        },
        error: error => {
          console.log(error);
          let _errorMsj = "Ha ocurrido un error al intentar descargar los datos. Por favor consulte a su administrador.";
          let _errorKey = 'common.error500_download';

          if (error.status == 500) {
            _errorKey = "common.error500_download_file";
          }
          else if (error.status == 0) {
            _errorKey = "common.error0_download";
          }

          this.translate.stream(_errorKey).subscribe((res: string) => {
            console.log(res);
            _errorMsj = res;
          });

          this.eventService.errorMessage(0, _errorMsj);
          this.eventService.completeLoadingData();
          this.waitFor = false;
        }
      });

    } catch (error) {
      console.log(error);
      this.eventService.completeLoadingData();
      this.waitFor = false;
    }
  }



  getParameters(): string {
    let _util = new utilsApps();
    let filter = "e.person_id::" + this.childId;

    let periodStartDate = this.fmFilters.get("txtDateInit")?.value;
    let periodStartHour = "00:00";
    let periodEndDate = this.fmFilters.get("txtDateEnd")?.value;
    let periodEndHour = "23:59";

    if (periodStartDate != null && periodEndDate != null) {
      let dateStart = _util.fnDateToString(periodStartDate, "-") + "T" + periodStartHour + ":00" + _util.GetTimeZoneOffset();
      let dateEnd = _util.fnDateToString(periodEndDate, "-") + "T" + periodEndHour + ":59" + _util.GetTimeZoneOffset();
      let creationDate = dateStart + '%23' + dateEnd;
      filter += ',e.creation_date@bt::' + creationDate;
    }

    console.log(filter);

    return filter;
  }

  onLoadGrid(isFilterByUser: boolean) {

    if (isFilterByUser) {
      this.currentPage = this.paginationTableService.resetPageCurrent();
    }

    this.waitFor = true;
    this.eventService.startLoadingData();
    let _parametros = this.getParameters();

    this._serviceWokingDay.getDataGrid(_parametros, this.currentPage)
      .then(res => {
        console.log("onLoadGrid=> ", res);

        if (res != null) {
          this.waitFor = false;
          let resultData = res;
          let contentJson = JSON.parse(resultData);

          console.log("contentJson=> ", contentJson);

          this.dataInformation = contentJson.rolls.records;
          this.userDetail.totalHours = contentJson.totalHours;

          this.dataInformation.forEach((element: any) => {

            element.typeNameStart = '';
            if (!element.workStart) {
              element.workStart = { type: 'null' };
            } else {
              element.dateStart = new Date(element.workStart.creationDate);
              switch (element.workStart?.type) {
                case 'work.start':
                  element.typeNameStart = 'Entrada laboral';
                  break;
                case 'work.end':
                  element.typeNameStart = 'Salida laboral';
                  break;
                case 'lunch.end':
                  element.typeNameStart = 'Salida al almuerzo';
                  break;
                case 'lunch.start':
                  element.typeNameStart = 'Entrada del almuerzo';
                  break;
                case 'evidence':
                  element.typeNameStart = 'Evidencia';
                  break;
                case 'assistance':
                  element.typeNameStart = 'Asistencia a instalaciones';
                  break;
                default:
                  element.typeNameStart = element.workStart.type;
                  break;
              }
            }


            element.typeNameEnd = '';
            if (!element.workEnd) {
              element.workEnd = { type: 'null' };
            }
            else {

              element.dateEnd = new Date(element.workEnd.creationDate);
              switch (element.workEnd?.type) {
                case 'work.start':
                  element.typeNameEnd = 'Entrada laboral';
                  break;
                case 'work.end':
                  element.typeNameEnd = 'Salida laboral';
                  break;
                case 'lunch.end':
                  element.typeNameEnd = 'Salida al almuerzo';
                  break;
                case 'lunch.start':
                  element.typeNameEnd = 'Entrada del almuerzo';
                  break;
                case 'evidence':
                  element.typeNameEnd = 'Evidencia';
                  break;
                case 'assistance':
                  element.typeNameEnd = 'Asistencia a instalaciones';
                  break;
                default:
                  element.typeNameEnd = element.workEnd.type;
                  break;
              }

            }

          });
          ;

          console.log("dataInformation=> ", this.dataInformation);
          this.dataGrid = this.dataInformation;
          this.totalPages = contentJson.rolls.pages;
          this.totalItems = contentJson.rolls.total;
          this.resetTable = false;
          localStorage.setItem('isInitLoad', '0');
          this.emptyDataList = contentJson.rolls.total == 0;
          this.IsPostBack = true;
        }
        else {

          this.translate.stream('common.error500').subscribe((res: string) => {
            this.eventService.errorMessage(0, res);
          });

        }

        this.eventService.completeLoadingData();
        this.waitFor = false;
      })
      .catch(error => {
        console.log(error);
        this.eventService.completeLoadingData();
        this.waitFor = false;
      });
  }


  onLoadEntity() {
    try {

      this.eventService.startLoadingData();



      console.log("_group=>", this._group);

      this._service.GetUserCaeGroup(this.childId).subscribe({
        next: res => {
          console.log("GetUserCaeGroup=>", res);

          if (res.ok) {
            let result = JSON.parse(res.body.content);
            console.log("result=>", result);

            if (result.records.length >= 1) {
              this._group = result.records[0];
              console.log("_group=>", this._group);
              this.userDetail.groupName = this._group.name;
            }

          }
          else {
            this.translate.stream('common.error500').subscribe((res: string) => {
              this.eventService.errorMessage(0, res);
            });
          }

        },
        error: error => {
          console.log(error);
        }
      });

      this._service.GetUserCae(this.childId).subscribe({
        next: res => {
          console.log(res);

          if (res.ok) {

            let resultData = res.body;
            let caeUserEntity = JSON.parse(resultData.content);
            console.log("GetUserCae =>", caeUserEntity);

            this.userDetail.fullname = caeUserEntity.name;
            this.userDetail.email = caeUserEntity.email;
            this.userDetail.idPlatform = caeUserEntity.platformId;
            this.userDetail.dateInit = caeUserEntity.period_start;
            this.userDetail.filePhoto = caeUserEntity.face;
            this.userDetail.position = caeUserEntity.position;

          }
          else {
            this.translate.stream('common.error500').subscribe((res: string) => {
              this.eventService.errorMessage(0, res);
            });
          }
          this.eventService.completeLoadingData();

        },
        error: error => {
          console.log(error);
        }
      });
    } catch (error) {
      console.log(error);
    }

  }

  protected changePage($event: any): void {
    this.currentPage = $event;
    this.onLoadGrid(false);
  }


  displayImage(template: TemplateRef<any>) {
    this.modalConfig.class = 'modal-lg';
    this.modalRef = this.modalService.show(template, this.modalConfig);
    this.imagePath = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,'
      + this.userDetail.filePhoto);
  }



  protected onClose(action: number): void {
    this.modalRef?.hide();
    this.modalRef = null;
  }



}
